import {GroupButton} from "../../common";
import EditIcon from "../../../assets/icons/EditIcon";
import {AddSquareIcon, CalendarIcon} from "../../../assets/icons";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import React from "react";
import {CustomerT} from "../../../types";
import {useLocation, useNavigate} from 'react-router-dom';

interface CustomerHeaderProps {
  customer: CustomerT;
  toggleDrawer: () => void;
  setShowPrompt: (show: boolean) => void;
  setIsSidebarOpen: (show: boolean) => void;
}

export const CustomerHeader: React.FC<CustomerHeaderProps> = ({ customer, toggleDrawer, setShowPrompt, setIsSidebarOpen }) => {
  const navigate = useNavigate();

  const handleCreateInvoice = () => {
    const customerId = customer?.id ?? '';
    const customerName = `${customer?.firstName} ${customer?.lastName}`;
    navigate(`/invoices/create?customerId=${encodeURIComponent(customerId)}&customerName=${encodeURIComponent(customerName)}`);
  };
  
  return (
  <div className="flex gap-[47px] mt-[50px] xl:mt- biglg:mt-[5em]">
    <h3 className="font-semibold  text-[#000000]  text-[18px]  md:text-[25px] lg:text-[25px] leading-8 tracking-wide mt-[-2em] xl:mt-[0.5em] ml-[-2em] md:ml-[0em] xl:ml-[0] lg:ml-[0.4em] 540:ml-[3.5em] lg:mt-[-1.5em] "  style={{ whiteSpace: 'nowrap' }}> {customer?.firstName} {customer?.lastName}</h3>
    <div className="flex justify-center xl:text-[17px] text-[20px] mt-[0.2em] md:text-[15px]  ml-[-7.7em] xl:mt-[-0.3em] xl:ml-[7em] md:mt-[2em] md:ml-[-12.5em] biglg:ml-[7em] biglg:mt-[-2.7em] lg:mt-[-2.9em] lg:ml-[4em] 540:ml-[-7.5em] ">
    <GroupButton
      buttons={[
        {
          text: 'Edit',
          icon: <EditIcon />,
          onClick: toggleDrawer,
        
        },
        {
          text: 'Send Reminders',
          icon: <CalendarIcon />,
          onClick: () =>  setIsSidebarOpen(true),
      
        },
        {
          text: 'Create Invoice',
          icon: <AddSquareIcon />,
          onClick: handleCreateInvoice,
       
        },
        {
          text: 'Delete ',
          icon: <DeleteIcon />,
          onClick: () => setShowPrompt(true),
          textColorClass: 'text-[#FB0303]',
        },
      ]}
    />
      
    </div>
    
  </div>
 );
};